<template>
  <div class="search-box">
    <div
      v-for="(item, index) in formData"
      :key="index">
      <!-- 普通选择 -->
      <el-select
        v-if="item.typeName === 'select1'"
        v-model="isQuery[item.model]"
        :placeholder="item.placeholder"
        class="form-item select-width"
        clearable
        @change="search"
      >
        <el-option
          v-for="v in item.options"
          :key="v.value"
          :label="v.label"
          :value="v.value"
        />
      </el-select>
      <!-- 普通输入框 -->
      <el-input
        v-if="item.typeName === 'input'"
        v-model="isQuery[item.model]"
        :placeholder="item.placeholder"
        class="form-item select-width"
        clearable
        @keyup.enter.native="search"
      />
      <!-- 输入框搜索 -->
      <el-input
        v-if="item.typeName === 'inputSearch'"
        v-model="isQuery[item.model]"
        :placeholder="item.placeholder"
        class="form-item input-search-width"
        clearable
        @keyup.enter.native="search"
      >
        <el-button
          slot="append"
          class="btn"
          size="small"
          @click="search"
        >搜索</el-button
        >
      </el-input>
      <!-- 带下拉的输入框搜索 -->
      <el-input
        v-if="item.typeName === 'inputSelectSearch'"
        :placeholder="item.options.filter(a=>a.value === item.model)[0].label"
        v-model="isQuery[item.model]"
        class="form-item"
        style="width: 450px"
        clearable
      >
        <el-select
          slot="prepend"
          v-model="item.model"
          style="width: 150px"
          placeholder="请选择"
          @change="handlerChange"
        >
          <el-option
            v-for="v in item.options"
            :key="v.value"
            :label="v.label"
            :value="v.value"
          />
        </el-select>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search"
        />
      </el-input>
      <!-- 日期 -->
      <el-date-picker
        v-if="item.typeName === 'daterange'"
        v-model="dateVal"
        :start-placeholder="item.startPlaceholder"
        :end-placeholder="item.endPlaceholder"
        :default-time="['00:00:00', '23:59:59']"
        type="daterange"
        class="form-item"
        style="width: 300px"
        range-separator="~"
        value-format="yyyy-MM-dd HH:mm:ss"
      />
    </div>
    <el-button
      v-if="isSearch"
      class="search-btn"
      icon="el-icon-search"
      @click="search"/>
    <el-button
      v-if="isAdd"
      class="search-btn"
      type="primary"
      @click="create"
    >新建</el-button
    >
  </div>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    isQuery: {
      type: Object,
      required: true,
    },
    formData: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateVal: null,
    };
  },
  methods: {
    search() {
      const obj = { ...this.isQuery };
      Object.keys(obj).forEach((key) => {
        // if (!obj[key]) delete obj[key];
        if (obj[key] === '' || obj[key] === null || obj[key] === undefined) delete obj[key];
      });
      this.$emit('update:isQuery', obj);
      this.$emit('onSearch', this.dateVal);
    },
    handlerChange(v) {
      const obj = { ...this.isQuery };
      const filterArr = this.formData.filter(item => item.typeName === 'inputSelectSearch');
      filterArr[0].options.forEach((item) => {
        if (item.value !== v) {
          delete obj[item.value];
        }
      });
      this.$emit('update:isQuery', obj);
    },
    create() {
      this.$emit('onCreate');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.form-item {
  margin-right: 10px;
  margin-bottom: 10px;
}
.select-width {
  width: 200px;
}
.input-search-width {
  width: 400px;
}
.search-btn{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFilter/index.vue